// Mapeia código de erro -> rótulo curto + cor. Adicione novos códigos aqui.
export interface CauseMeta {
  label: string;
  color: string;
  description: string;
}

export const ERROR_CATALOG: Record<string, CauseMeta> = {
  '551': { label: 'Indisponível #551', color: '#f59e0b', description: '(#551) Esta pessoa não está disponível no momento.' },
  '2022': { label: 'Página restrita #2022', color: '#8b5cf6', description: 'Página com restrição temporária do Meta — envio bloqueado na origem (nenhuma tentativa foi feita)' },
  '613': { label: 'Limite Meta #613', color: '#ef4444', description: '(#613) Limite de envio da Meta' },
  '10': { label: 'Sem permissão #10', color: '#0ea5e9', description: 'Application does not have permission for this action' },
  '1': { label: 'Excesso de dados #1', color: '#64748b', description: "Please reduce the amount of data you're asking for, then retry your request" },
  sem_codigo: { label: 'Sem código (registro antigo)', color: '#94a3b8', description: 'Falha gravada antes de 18/09, quando o flow salvava uma frase no lugar do código da Meta' },
  sem_lead_elegivel: { label: 'Sem lead elegível', color: '#cbd5e1', description: 'Nenhum lead elegível nas páginas no momento do disparo — nada foi enviado' },
};

export function causeMeta(key: string, message?: string): CauseMeta {
  return ERROR_CATALOG[key] ?? { label: `Erro #${key}`, color: '#94a3b8', description: message ?? key };
}
